import clsx from "clsx";
import { useRouter } from "next/router";

export const ClearFilter = ({
  label = "清除所有選項",
  className,
}: {
  label?: string;
  className?: string;
}) => {
  const { asPath, push } = useRouter();

  return (
    <div
      className={clsx(
        "text-primary cursor-pointer whitespace-nowrap text-sm font-normal",
        className,
      )}
      onClick={() =>
        push({ pathname: asPath.split("?")[0] }, undefined, {
          scroll: false,
          shallow: true,
        })
      }
    >
      {label}
    </div>
  );
};
